import { type HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

/** Loading placeholders are skeletons at content shape, never spinners replacing
 *  a list — the layout must not collapse while data arrives. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
